import * as React from 'react'

class ContactForm extends React.Component {
    render() {
        return (
            <div className="ecf-form-donate__item-contact-form">
                <div className="ecf-form-donate__item-contact-form-container">
                    <h4 className="ecf-form-donate__item-contact-form-title section-item-title">
                        How should we address you?
                    </h4>
                    <div className="ecf-form-donate__item-contact-form-gene">
                        <div className="ecf-form-donate__item-contact-form-gene-item">
                            Mr
                        </div>
                        <div className="ecf-form-donate__item-contact-form-gene-item">
                            Mdm
                        </div>
                        <div className="ecf-form-donate__item-contact-form-gene-item">
                            Ms
                        </div>
                    </div>
                    <div className="ecf-form-donate__item-contact-form-name input-field">
                        <label htmlFor="formName">
                            <input type="text" name="formName" id="formName" placeholder="Preferred name"/>
                        </label>
                    </div>
                    <div className="ecf-form-donate__item-contact-form-check-box">
                        <div>
                            <input
                                name="hideName"
                                type="checkbox"
                                id="hideName"
                                value="hide-name"
                                // checked={this.state.isGoing}
                                // onChange={this.handleInputChange} 
                                />
                            <label htmlFor="hideName" >
                                <span>
                                    Hide your name on our website
                                </span>
                            </label>
                        </div>
                        <div>
                            <input
                                name="dedicateDonate"
                                type="checkbox"
                                id="dedicateDonate"
                                value="dedicate-donation"
                                // checked={this.state.isGoing}
                                // onChange={this.handleInputChange} 
                                />
                            <label htmlFor="dedicateDonate" >
                                <span>
                                Dedicate this donation
                                </span>
                            </label>
                        </div>
                    </div>
                    <h4 className="ecf-form-donate__item-contact-form-title section-item-title">
                        How should we contact you?
                    </h4>
                    <div className="ecf-form-donate__item-contact-form-name input-field">
                        <label htmlFor="formEmail">
                            <input type="email" name="formEmail" id="formEmail" placeholder="Your email address"/>
                        </label>
                    </div>
                    <div className="ecf-form-donate__item-contact-form-name input-field">
                        <label htmlFor="formPhone">
                            <input type="number" name="formPhone" min="0" id="formPhone" placeholder="Your mobile number"/>
                        </label>
                    </div>
                </div>
            </div>
        )
    }
}

export default ContactForm;